import React, { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Alert, Typography } from '@mui/material';
import { loadKpiData } from '../actions/Beacon4BlendedActions';
import Beacon4BlendedKpiCard from './cards/Beacon4BlendedKpiCard';

const Beacon4BlendedView = forwardRef((props, ref) => {
    const dispatch = useDispatch();
    const { platform, type, side, selectedPolygons } = useSelector(s => s.filters);
    const { configs, series, loading, error } = useSelector(s => s.kpiData);

    useEffect(() => {
        if (!side) return;
        dispatch(loadKpiData({ platform, type, side, polygons: selectedPolygons }));
    }, [platform, type, side, selectedPolygons, dispatch]);

    if (error)
        return <Box sx={{ p: 2 }}><Alert severity="error">Failed to load KPI data: {String(error)}</Alert></Box>;

    if (!side)
        return <Box sx={{ p: 2 }}><Alert severity="info">Select a side to load KPI data.</Alert></Box>;

    const getSeriesFor = (kpiKey) => series.find(s => s.kpiKey === kpiKey) ?? null;

    const polyLabel = selectedPolygons.length === 0 ? 'All polygons'
                    : selectedPolygons.length === 1 ? selectedPolygons[0]
                    : `AVG of ${selectedPolygons.length} polygons`;

    return (
        <Box ref={ref}>
            <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1.25, fontSize: 11 }}>
                <strong>{polyLabel}</strong> · {side}
            </Typography>
            {configs.map(cfg => (
                <Beacon4BlendedKpiCard key={cfg.kpiKey} config={cfg} series={getSeriesFor(cfg.kpiKey)} loading={loading} />
            ))}
        </Box>
    );
});

export default Beacon4BlendedView;